import {
  Infer,
  array,
  boolean,
  enums,
  literal,
  number,
  object,
  optional,
  string,
  union,
} from "superstruct";
import { cfJsonAnchorSchema } from "components/Anchor/schema";

const colorListSchema = enums([
  "aqua",
  "black",
  "figc",
  "grey",
  "green",
  "pink",
  "red",
  "yellow",
  "recycled-green",
  "blue",
  "orange",
  "football",
]);

const offerDetailSchema = union([
  object({
    variant: literal("description"),
    label: string(),
    description: string(),
    tooltip: optional(string()),
  }),
  object({
    variant: literal("checkIcon"),
    label: string(),
    isChecked: boolean(),
    tooltip: optional(string()),
  }),
  object({
    variant: literal("numericValue"),
    label: string(),
    value: number(),
  }),
  object({
    variant: literal("colorList"),
    label: string(),
    colorList: array(colorListSchema),
    tooltip: optional(string()),
  }),
  object({ variant: literal("promo"), description: string() }),
]);

export const cfCardOfferSchema = object({
  contentful_id: string(),
  __typename: string(),
  title: string(),
  price: optional(string()),
  priceDetail: optional(string()),
  ctaLabel: optional(string()),
  ctaAnchor: cfJsonAnchorSchema,
  badgeLabel: optional(string()),
  showMoreLabel: string(),
  variant: enums(["dark", "light"]),
  isMobileFullShown: optional(boolean()),
  detailList: array(offerDetailSchema),
});

export type CardOfferNewSchema = Infer<typeof cfCardOfferSchema>;

export type CfCardOfferProps = {
  dataJson: CardOfferNewSchema;
  identifiers: { contentful_id: string; __typename: string };
};
